import { loading } from './modules/01_loading';
import { drawerMenu } from './modules/02_drawerMenu';
import { pageTop } from './modules/03_pageTop';
import { anchorLink } from './modules/04_anchorLink';
import { fadeinEffect } from './modules/05_fadeinEffect';
import { initColorbox } from './modules/06_colorbox';

jQuery(function ($) {
  loading($);
  drawerMenu($);
  pageTop($);
  fadeinEffect($);
  initColorbox($);
});

// jQuery不要な処理は外で実行
anchorLink();
